/**
 * Actions that users can perform on subjects
 */
export enum UserActionEnum {
	/**
	 * View
	 * @description Can view the subject
	 */
	VIEW = 'view',

	/**
	 * Create
	 * @description Can create the subject
	 */
	CREATE = 'create',

	/**
	 * Update
	 * @description Can update the subject
	 */
	UPDATE = 'update',

	/**
	 * Delete
	 * @description Can delete the subject
	 */
	DELETE = 'delete',

	/**
	 * Manage
	 * @description Reserved by CASL for `All` actions on a subject
	 */
	MANAGE = 'manage',
}
